import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const itemsPerPageMobileOptions = [10, 25];

const itemsPerPageDesktopOptions = [24, 48];

interface PageControllersProps {
  currentPage: number;
  setPage: Function;
  lastPage: number | undefined;
  withNumbers?: boolean;
  withArrows?: boolean;
  itemsPerPage: number;
  setItemsPerPage: Function;
}

const PageControllers = ({
  currentPage,
  setPage,
  lastPage,
  withNumbers,
  withArrows,
  itemsPerPage,
  setItemsPerPage,
}: PageControllersProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [pages, setPages] = useState<Array<any>>([]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const setPreviousPage = () => {
    setPage(currentPage - 1);
  };
  const setNextPage = () => {
    setPage(currentPage + 1);
  };

  useEffect(() => {
    scrollToTop();
  }, [currentPage]);

  useEffect(() => {
    if (lastPage && withNumbers === true) {
      const tempMinPage = currentPage - 3 < 1 ? 1 : currentPage - 3;
      const tempMaxPage =
        currentPage + 3 > lastPage ? lastPage : currentPage + 3;
      let tempPages: Array<any> = [];
      if (tempMinPage !== 1) {
        tempPages.push(<Box>...</Box>);
      }
      for (let i = tempMinPage; i <= tempMaxPage; i++) {
        tempPages.push(
          <Box>
            <IconButton
              disabled={currentPage === i}
              onClick={() => setPage(i)}
              sx={{
                ml: "auto",
                width: "30px",
                height: "30px",
                backgroundColor:
                  currentPage === i
                    ? "#4663FF !important"
                    : "#DBE3EA !important",
                color:
                  currentPage === i ? "white !important" : "#A7AFBD !important",
                fontSize: "20px",
              }}
            >
              {i}
            </IconButton>
          </Box>
        );
      }

      if (tempMaxPage !== lastPage) {
        tempPages.push(<Box>...</Box>);
      }
      setPages(tempPages);
    }
  }, [currentPage, lastPage]);

  return (
    <Box
      sx={{
        display: { xs: "block", md: "flex" },
        alignItems: "center",
        justifyContent: "center",
        marginX: "auto",
        marginY: "32px",
        gap: "100px",
        position: "relative",
        width: "100%",
      }}
    >
      <FormControl
        fullWidth
        sx={{
          width: 150,
          position: { xs: "relative", md: "absolute" },
          left: 10,
          marginRight: "10px",
          marginBottom: { xs: "10px", md: "0px" },
        }}
        size="small"
      >
        <InputLabel id="items-per-page-label">Items Per Page</InputLabel>
        <Select
          labelId="items-per-page-label"
          value={itemsPerPage}
          label="Items Per Page"
          onChange={(event) =>
            setItemsPerPage && setItemsPerPage(event.target.value as number)
          }
        >
          {isMobile
            ? itemsPerPageMobileOptions.map((item, index) => (
                <MenuItem
                  value={item}
                  sx={{ fontSize: "16px !important" }}
                  key={`page-controller-itemsPerPage-mobile-${index}`}
                >
                  {item}
                </MenuItem>
              ))
            : itemsPerPageDesktopOptions.map((item, index) => (
                <MenuItem
                  value={item}
                  sx={{ fontSize: "16px !important" }}
                  key={`page-controller-itemsPerPage-desktop-${index}`}
                >
                  {item}
                </MenuItem>
              ))}
        </Select>
      </FormControl>

      <Box
        sx={{
          display: "flex",
          columnGap: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {withArrows === true && (
          <Box>
            <IconButton
              disabled={currentPage === 1}
              onClick={setPreviousPage}
              sx={{ ml: "auto" }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Box>
        )}
        {withNumbers === true &&
          pages.map((p, index) => <Box key={index}>{p}</Box>)}
        {withArrows === true && (
          <Box>
            <IconButton
              disabled={currentPage === lastPage}
              onClick={setNextPage}
              sx={{ ml: "auto" }}
            >
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PageControllers;
